import { UserPermissionHeader } from 'components/user/user-permission-header/user-permission-header'
import { InheritedPermissions } from 'components/user/user-permission-list/user-permission-list'
import { useTranslate } from 'utils'
import { theme } from 'antd'
import {
    RightOutlined,
    UserOutlined, ShopOutlined,
    CalendarOutlined,
    EnvironmentOutlined
} from '@ant-design/icons'
import { VerticalContainer } from 'components/styled'
import { Avatar } from 'components/avatar/avatar'
import { Feature, PermissionType } from 'types'
import { useConfig } from 'api'

type Props = {
    inheritedPermissions: InheritedPermissions
    onBack: () => void
    onSelect: (type: PermissionType) => void
}

export const UserPermissionTypeSelect = ({ inheritedPermissions, onBack, onSelect }: Props) => {

    //hooks:
    const { __ } = useTranslate()
    const { token: {
        marginMD,
        marginXS,
        fontSizeSM,
        fontSizeLG,
        paddingSM,
        paddingLG,
        colorText,
        colorBgSpotlight
    }} = theme.useToken()
    const { data: config } = useConfig()

    //getIcon:
    const getIcon = (type: PermissionType) => {
        inheritedPermissions
        switch(type){
            case PermissionType.Shop:
                return <ShopOutlined/>
            case PermissionType.Location:
                return <EnvironmentOutlined/>
            // case PermissionType.Service:
            //     return <CustomerServiceOutlined/>
            case PermissionType.Resource:
                return <UserOutlined/>
            case PermissionType.Appointment:
                return <CalendarOutlined/>
            // case PermissionType.Flow:
            //     return <RetweetOutlined style={{ fontSize: fontSizeXL }}/>
        }
    }

    //getDescription:
    const getDescription = (type: PermissionType) => {
        switch(type){
            case PermissionType.Shop:
                return __`grant_shop_permission_to_create_an_admin`
            case PermissionType.Location:
                return __`user_can_access_to_a_specific_location`
            // case PermissionType.Service:
            //     return __`user_can_read_write_or_manage_a_service`
            case PermissionType.Resource:
                return __`user_can_access_to_resources`
            case PermissionType.Appointment:
                return __`user_can_read_or_manage_appointments`
            // case PermissionType.Flow:
            //     return __`user_can_read_write_or_manage_a_flow`
        }
    }

    return config ? (
        <VerticalContainer style={{ gap: marginMD }}>

            {/* header */}
            <UserPermissionHeader
                title={__`permission`}
                description={__`select_the_type_of_permission_you_want_to_grant`}
                onBack={onBack}
            />

            <VerticalContainer style={{ paddingBottom: paddingSM, gap: marginXS }}>

                {/* list */}
                {(Object.keys(PermissionType) as PermissionType[]).map(type => (
                    <Avatar
                        key={type}
                        name={__(type.toString().toLowerCase())}
                        image={null}
                        placeholder={<div style={{ fontSize: fontSizeLG, color: colorBgSpotlight }}>{getIcon(type)}</div>}
                        description={getDescription(type)}
                        color={colorText}
                        backgroundColor='transparent'
                        size='small'
                        extraIcon={<RightOutlined style={{ fontSize: fontSizeSM }}/>}
                        style={{ paddingLeft: paddingSM, paddingRight: paddingLG, borderRadius: 0 }}
                        isDisabled={!config.features.includes(Feature.PERMISSIONS) && type !== PermissionType.Shop}
                        onClick={() => onSelect(type)}
                    />
                ))}

            </VerticalContainer>

        </VerticalContainer>
    ) : <></>
    
}
